import styled from 'styled-components';
import { media } from '../../../../../theme/shared/breakpoints';
export const PromoBarWrapper = styled.div `
  background-color: ${({ backgroundColor }) => backgroundColor || 'blue'};
  color: ${({ fontColor }) => fontColor || 'white'};
  width: 100%;
  transform: translateY(0);
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  height: ${({ isVisible }) => (isVisible ? 'unset' : '0px')};
  padding: ${({ isVisible }) => (isVisible ? '8px 16px' : 'unset')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: ${({ isVisible }) => (isVisible ? 0 : -1)};

  ${media.medium} {
    flex-direction: row;
  }

  ${media.large} {
    position: absolute;
    top: ${({ isVisible }) => (isVisible ? '141px' : '82px')};
    transition: ${({ isVisible }) => (isVisible ? 'top 0.3s ease, opacity 0.3s ease' : 'none')};
    z-index: -1;
  }
`;
export const PromoTextWrapper = styled.div `
  margin-bottom: 8px;

  ${media.small} {
    margin-right: 24px;
    margin-bottom: 0;
  }
`;
export const PromoBarCloseIconWrapper = styled.div `
  position: absolute;
  right: 16px;
  top: calc(50% - 12px);

  ${media.small} {
    position: static;
    margin-left: 24px;
  }
`;
export const PromoBarCloseIcon = styled.div `
  width: 24px;
  height: 24px;
  position: relative;
  cursor: pointer;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 20px;
    height: 2px;
    background-color: ${({ color }) => color || 'white'};
    transform: translate(-50%, -50%) rotate(45deg);
  }

  &::before {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
`;
//# sourceMappingURL=PromoBar.styled.js.map